import { useRollCompetitions } from '@/api/roll-competitions';
import useRollCompetitionTimeLeft from '@/hooks/roll-point/useRollCompetitionTimeLeft';
import { ErrorCard, TransWithDefault } from '@starsoft/common/components';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import RollCompetitionContentHeader from './Header';
import RollCompetitionContentRenderer from './Renderer';
import RollCompetitionContentSkeleton from './Skeleton';
import RollPointGameContentSlot from './Slot';
import styles from './styles.module.scss';
import RollCompeititonContentTabs from './Tabs';

export default function RollCompetitionContent() {
  const { error, isPending, refetch, rollCompetition } = useRollCompetitions();
  const { formattedTimeLeft } = useRollCompetitionTimeLeft();

  if (error) {
    return (
      <div className={styles.container}>
        <ErrorCard error={error} refetch={refetch} />
      </div>
    );
  }

  if (isPending) {
    return <RollCompetitionContentSkeleton />;
  }

  return (
    <div
      className={`${styles.container} ${styles[`container--${process.env.NEXT_PUBLIC_TENANT_ID}`]}`}
      style={{
        //@ts-ignore
        '--frame': `url(${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/roll-competition/${process.env.NEXT_PUBLIC_TENANT_ID === 'kube' ? 'roll-comp-money-coin' : 'frame-roll'}.png)`,
        '--frame-bg': ['ice', 'gli'].includes(process.env.NEXT_PUBLIC_TENANT_ID)
          ? `url(${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/roll-competition/background-roll.png)`
          : `url(${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/roll-competition/roll-comp-slot.png)`,
      }}
    >
      <div className={styles.container__content}>
        <RollCompetitionContentHeader />
        <div className={styles.container__content__card}>
          <div className={styles.container__content__row}>
            <div className={`${styles.container__content__row__label}`}>
              <TransWithDefault
                i18nKey="common:expires_in"
                values={{
                  countdown: formattedTimeLeft,
                }}
              />
            </div>
            <div className={styles.container__content__row__label}>
              <TransWithDefault
                i18nKey="common:cycle_reward"
                values={{
                  amount: WalletService.maskCurrency({
                    amount: getMoneyOrAmount(rollCompetition?.prize),
                    coin: rollCompetition?.coin,
                  }),
                }}
              />
            </div>
          </div>
          <RollPointGameContentSlot />
        </div>
        <div className={styles.container__content__tabs}>
          <RollCompeititonContentTabs />
        </div>
        <RollCompetitionContentRenderer />
      </div>
    </div>
  );
}
